import z from "./index.es242.js";
import t from "./index.es119.js";
import S from "./index.es130.js";
import ee from "./index.es340.js";
import { trackStream as J } from "./index.es341.js";
import te from "./index.es133.js";
import { progressEventDecorator as K, progressEventReducer as M, asyncDecorator as V } from "./index.es338.js";
import re from "./index.es339.js";
import oe from "./index.es336.js";
const W = 64 * 1024, { isFunction: C } = t, ne = (({ Request: o, Response: n }) => ({
  Request: o,
  Response: n
}))(t.global), {
  ReadableStream: j,
  TextEncoder: G
} = t.global, Q = (o, ...n) => {
  try {
    return !!o(...n);
  } catch {
    return !1;
  }
}, se = (o) => {
  o = t.merge.call({
    skipUndefined: !0
  }, ne, o);
  const { fetch: n, Request: a, Response: b } = o, h = n ? C(n) : typeof fetch == "function", l = C(a), F = C(b);
  if (!h)
    return !1;
  const y = h && C(j), R = h && (typeof G == "function" ? /* @__PURE__ */ ((e) => (r) => e.encode(r))(new G()) : async (e) => new Uint8Array(await new a(e).arrayBuffer())), d = l && y && Q(() => {
    let e = !1;
    const r = new a(z.origin, {
      body: new j(),
      method: "POST",
      get duplex() {
        return e = !0, "half";
      }
    }).headers.has("Content-Type");
    return e && !r;
  }), m = F && y && Q(() => t.isReadableStream(new b("").body)), x = {
    stream: m && ((e) => e.body)
  };
  h && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((e) => {
    !x[e] && (x[e] = (r, g) => {
      let i = r && r[e];
      if (i)
        return i.call(r);
      throw new S(`Response type '${e}' is not supported`, S.ERR_NOT_SUPPORT, g);
    });
  });
  const X = async (e) => {
    if (e == null)
      return 0;
    if (t.isBlob(e))
      return e.size;
    if (t.isSpecCompliantForm(e))
      return (await new a(z.origin, {
        method: "POST",
        body: e
      }).arrayBuffer()).byteLength;
    if (t.isArrayBufferView(e) || t.isArrayBuffer(e))
      return e.byteLength;
    if (t.isURLSearchParams(e) && (e = e + ""), t.isString(e))
      return (await R(e)).byteLength;
  }, Y = async (e, r) => t.toFiniteNumber(e.getContentLength()) ?? X(r);
  return async (e) => {
    let {
      url: r,
      method: g,
      data: i,
      signal: Z,
      cancelToken: N,
      timeout: I,
      onDownloadProgress: L,
      onUploadProgress: U,
      responseType: c,
      headers: v,
      withCredentials: E = "same-origin",
      fetchOptions: $
    } = re(e), q = n || fetch;
    c = c ? (c + "").toLowerCase() : "text";
    let O = ee([Z, N && N.toAbortSignal()], I), T = null;
    const p = O && O.unsubscribe && (() => {
      O.unsubscribe();
    });
    let A;
    try {
      if (U && d && g !== "get" && g !== "head" && (A = await Y(v, i)) !== 0) {
        let u = new a(r, {
          method: "POST",
          body: i,
          duplex: "half"
        }), w;
        if (t.isFormData(i) && (w = u.headers.get("content-type")) && v.setContentType(w), u.body) {
          const [B, P] = K(
            A,
            M(V(U))
          );
          i = J(u.body, W, B, P);
        }
      }
      t.isString(E) || (E = E ? "include" : "omit");
      const s = l && "credentials" in a.prototype, D = {
        ...$,
        signal: O,
        method: g.toUpperCase(),
        headers: v.normalize().toJSON(),
        body: i,
        duplex: "half",
        credentials: s ? E : void 0
      };
      T = l && new a(r, D);
      let f = await (l ? q(T, $) : q(r, D));
      const k = m && (c === "stream" || c === "response");
      if (m && (L || k && p)) {
        const u = {};
        ["status", "statusText", "headers"].forEach((_) => {
          u[_] = f[_];
        });
        const w = t.toFiniteNumber(f.headers.get("content-length")), [B, P] = L && K(
          w,
          M(V(L), !0)
        ) || [];
        f = new b(
          J(f.body, W, B, () => {
            P && P(), p && p();
          }),
          u
        );
      }
      c = c || "text";
      let H = await x[t.findKey(x, c) || "text"](f, e);
      return !k && p && p(), await new Promise((u, w) => {
        oe(u, w, {
          data: H,
          headers: te.from(f.headers),
          status: f.status,
          statusText: f.statusText,
          config: e,
          request: T
        });
      });
    } catch (s) {
      throw p && p(), s && s.name === "TypeError" && /Load failed|fetch/i.test(s.message) ? Object.assign(
        new S("Network Error", S.ERR_NETWORK, e, T),
        {
          cause: s.cause || s
        }
      ) : S.from(s, s && s.code, e, T);
    }
  };
}, ae = /* @__PURE__ */ new Map(), ie = (o) => {
  let n = o ? o.env : {};
  const { fetch: a, Request: b, Response: h } = n, l = [
    b,
    h,
    a
  ];
  let F = l.length, y = F, R, d, m = ae;
  for (; y--; )
    R = l[y], d = m.get(R), d === void 0 && m.set(R, d = y ? /* @__PURE__ */ new Map() : se(n)), m = d;
  return d;
};
ie();
export {
  ie as getFetch
};
//# sourceMappingURL=index.es246.js.map
